// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"79":"90ac5ac62448badf","249":"8b65c43ffacfd4b0","411":"1bc75d90ef1dc5cc","698":"2f21ac9c33ddef69"}[chunkId] + ".js";
};